import React from "react";
import { Spinner } from "react-bootstrap";

export default function Loader() {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "40vh",
    }}>
      <Spinner animation="border" style={{ color: "#6366f1" }} />
    </div>
  );
}
